import axios from 'axios';
import config from '../config';

/**
 * Per-IMEI condition video (Old Mobile). Server compresses to ≤5MB, max ~30s.
 */
export async function uploadUnitRealVideo(file, { productId, imeiIndex }) {
  if (!file) return { success: true, skipped: true };
  if (productId == null || imeiIndex == null) {
    return { success: false, error: 'productId and imeiIndex required' };
  }
  try {
    const fd = new FormData();
    fd.append('video', file);
    const res = await axios.post(
      `${config.API_URL}/products/${productId}/imei/${imeiIndex}/unit-real-video`,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 600000 }
    );
    return {
      success: true,
      videoUrl: res.data?.unitRealVideoUrl,
      processing: !!res.data?.processing,
      status: res.data?.unitRealVideoStatus || ''
    };
  } catch (err) {
    const msg = err.response?.data?.message || err.message || 'Video upload failed';
    console.warn('[uploadUnitRealVideo]', msg);
    return { success: false, error: msg };
  }
}
